<template>
    <div class="dingConnect">
        <div class="banner"></div>
        <div class="content">
            <p class="hh1">钉钉智能硬件生态开放</p>
            <ul class="showKuai">
                <li>
                    <img src="./img-info/img-zhilian-s1.png" alt="" loading="lazy">
                    <p class="p-p1">未来办公室打造计划</p>
                    <p class="p-p2">钉钉智能硬件，与钉钉智连生态合作伙伴一起，致力于为各行各业提供软硬一体的场景化解决方案，帮助企业实现数字化、智能化升级，打造“未来办公室”</p>
                </li>
                <li>
                    <img src="./img-info/img-zhilian-s2.png" alt="" loading="lazy">
                    <p class="p-p1">面向行业和用户</p>
                    <p class="p-p2">提供多样化的智能硬件设备，与合作伙伴一起，助力搭建基于钉钉的垂直行业软硬一体解决方案。 针对不同行业、不同身份的用户需求提供针对性的智能管理工具。</p>
                </li>
            </ul>
            <p class="hh1">多场景的深度融合</p>
            <p class="hh2">钉钉智能硬件已形成考勤、门禁、会议、网络、打印、五大类产品体系</p>
            <p class="hh3">覆盖多种场景的软硬一体化解决方案</p>
            <ul class="changjiang">
                <li>
                    <img src="./img-info/img-zhilian-s3.jpg" alt="" loading="lazy">
                </li>
                <li>
                    <img src="./img-info/img-zhilian-s4-tuya.jpg" alt="" loading="lazy">
                </li>
                <li>
                    <img src="./img-info/img-zhilian-s5-tuya.jpg" alt="" loading="lazy">
                </li>
                <li>
                    <img src="./img-info/img-zhilian-s6-tuya.jpg" alt="" loading="lazy">
                </li>
                <li>
                    <img src="./img-info/img-zhilian-s7-tuya.jpg" alt="" loading="lazy">
                </li>
                <li>
                    <img src="./img-info/img-zhilian-s8-tuya.jpg" alt="" loading="lazy">
                </li>
            </ul>
            <p class="hh1">丰富的合作品类解决方案</p>
            <ul class="shangpin">
                <li>
                    <img src="./img-info/img-zhilian-s9-tuya.png" alt="" loading="lazy">
                    <div class="jieshi">
                        <p class="p-shangpin1">智能考勤方案</p>
                        <p class="p-shangpin2">设备数据在线化，实现门禁控制的同时，考勤/打卡/签到数据实时查看。</p>
                        <p class="p-shangpin2">联合阿里达摩院，提供高性能的人脸识别算法。</p>
                        <p class="p-shangpin2">支持人脸识别、指纹识别、密码、刷卡等多种方式结合。</p>
                        <p class="p-shangpin2">支持人体测温、口罩识别、扫码识别等疫情期间的特殊需求。</p>
                    </div>
                </li>
                <li>
                    <img src="./img-info/img-zhilian-s10-tuya.png" alt="" loading="lazy">
                    <div class="jieshi">
                        <p class="p-shangpin1">智能门禁方案</p>
                        <p class="p-shangpin2">设备数据在线化，实现门禁控制的同时，考勤/打卡/签到数据实时查看。</p>
                        <p class="p-shangpin2">联合阿里达摩院，提供高性能的人脸识别算法。</p>
                        <p class="p-shangpin2">支持人脸识别、指纹识别、密码、刷卡等多种方式结合。</p>
                        <p class="p-shangpin2">支持人体测温、口罩识别、扫码识别等疫情期间的特殊需求。</p>
                    </div>
                </li>
                <li>
                    <img src="./img-info/img-zhilian-s11-tuya.png" alt="" loading="lazy">
                    <div class="jieshi">
                        <p class="p-shangpin1">智能打印方案</p>
                        <p class="p-shangpin2">打印设备在线化，与钉钉文档、审批流打通，实现多种文件在线打印。</p>
                        <p class="p-shangpin2">无需电脑，手机钉钉一键打印，节约手机存储空间。</p>
                        <p class="p-shangpin2">支持远程打印、私密扫码打印，适用多种打印场景。</p>
                        <p class="p-shangpin2">免装驱动，在线配置，直连云端，全员共享</p>
                    </div>
                </li>
                <li>
                    <img src="./img-info/img-zhilian-s12-tuya.png" alt="" loading="lazy">
                    <div class="jieshi">
                        <p class="p-shangpin1">智能网络方案</p>
                        <p class="p-shangpin2">更快更安全的数据传输，钉钉授权免密一键联网。</p>
                        <p class="p-shangpin2">智能隔离办公网络和访客网络，确保信息安全。</p>
                        <p class="p-shangpin2">可针对不同的团队设置不同的上网权限和网速。</p>
                        <p class="p-shangpin2">统一管理多地网络，保障多点办公高效运营。</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {

}
</script>
<style lang='less' scoped>
.dingConnect{
    width: 100%;
    .banner{
        width:100% ;
        height: 450px;
        background-image: url(./banner-pc-img/ddzl_1920337.5@1x-tuya.png);
        background-size: 100%;
        background-repeat: no-repeat;
    }
    .content{
        width: 80%;
        margin: 0 auto;
        margin-bottom: 30px;
        .hh1{
            width: 100%;
            font-size:42px;
            font-family:微软雅黑;
            color:#000000;
            text-align: center;
            margin-top: 30px;
            margin-bottom: 30px;
            font-weight: bold;
            padding: 40px;
        }
        .showKuai{
            width: 100%;
            margin-bottom: 72px;
            display: flex;
            align-items: center;
            justify-content: space-around;

            li{
                width: 45%;
                padding: 40px;
                box-sizing:border-box;
                background-color: rgba(245, 245, 245, 1);
                border-radius: 10px;
                text-align: left;
                img{
                    width: 60px;
                    height: 60px;
                }
                .p-p1{
                    margin-top: 7px;
                    color:#000000;
                    font-family:微软雅黑;
                    font-size:24px;
                    font-weight: bold;
                    line-height: 32px;
                }
                .p-p2{
                    color:#696969;
                    font-family:微软雅黑;
                    font-size:19px;
                    line-height: 28px;
                    margin-top: 10px;
                }
            }
        }
        .hh2,.hh3{
           width: 100%;
            font-size:22px;
            font-family:微软雅黑;
            color:#000000;
            text-align: center;
            padding: 10px;
        }
        .changjiang{
            width: 100%;
            margin-top: 30px;
            margin-bottom: 50px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            li{
                width: 31%;
                height: 370px;
                margin-bottom: 30px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .shangpin{
            width: 100%;
            // margin-top: 30px;
            // margin-bottom: 50px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            li{
                width: 48.5%;
                margin-bottom: 40px;
                background-color: rgba(245, 245, 245, 1);
                border-radius: 10px;
                display: flex;
                flex-direction: column;
                padding: 40px;
                padding-bottom: 20px;
                img{
                    width: 100%;
                    height: 276px;
                    border-radius: 10px 10px 0 0;
                }
                .jieshi{
                    width: 100%;
                    flex: 1;
                    box-sizing: border-box;
                    padding: 12px 20px 20px 30px;
                    .p-shangpin1{
                        line-height: 32px;
                        font-size:24px;
                        color:#000000;
                        font-family:微软雅黑;
                        text-align: left;
                        margin-bottom: 10px;
                    }
                    .p-shangpin2{
                        text-align: left;
                        line-height: 24px;
                        font-size:14px;
                        color:#696969;
                        font-family:微软雅黑;
                    }
                }
            }
        }

    }
}
</style>
